import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { getTransactionViewTrackingContext } from '@features/transactions/utils/getTransactionViewTrackingContext'
import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberEventFn } from '../../types/emberEventFn'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'transaction-view-module'

class TransactionViewWebComponent extends DOMModel {
  @byAttrVal('transactionid') transactionId: string
  @byAttrVal('organizationid') organizationId: string
  @byAttrVal('isdraweropen') isDrawerOpen: string
  @byAttrVal('trackingcontext') trackingContext: string
  @registerEvent('closeEmber') closeEmber: EmberEventFn
}

interface TransactionViewModuleProps {
  transactionId: string
  organizationId: string
  isDrawerOpen: 'true' | 'false'
  trackingContext?: string
  onCloseEmber: EmberEventFn
}

function TransactionViewModule({
  transactionId,
  organizationId,
  isDrawerOpen,
  trackingContext,
  onCloseEmber,
}: TransactionViewModuleProps): ReactElement {
  /* ember <=> react doesn't work well with booleans so we need to send a string */
  const isOpen = isDrawerOpen === 'true'

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <HistoryRouter>
          <ModalContextProvider>
            <CurrentUserContextProvider>
              <UserOrganizationContextProvider organizationId={organizationId}>
                <UserOrganizationSettingsContextProvider organizationId={organizationId}>
                  <AccountsContextProvider organizationId={organizationId}>
                    <TransactionViewProvider
                      isDrawerOpen={isOpen}
                      onCloseEmber={onCloseEmber}
                      trackingContext={getTransactionViewTrackingContext(trackingContext)}
                      transactionId={transactionId}
                    />
                  </AccountsContextProvider>
                </UserOrganizationSettingsContextProvider>
              </UserOrganizationContextProvider>
            </CurrentUserContextProvider>
          </ModalContextProvider>
        </HistoryRouter>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const TransactionViewCustomElement = createCustomElement(TransactionViewModule, TransactionViewWebComponent, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, TransactionViewCustomElement)

export default TransactionViewCustomElement
